<template>
	<div class="item_sidebar border_item_sidebar container-props active">
		<div class="wrapper_title" :class="{'mb_15':panelOpen}">
			<div class="title">{{ title }}</div>

			<a class="sidebar_item_open_arrow" :class="{'active':panelOpen}" @click="panelOpenToggle">
				<img src="@/modules/page-editor/src/assets/img/chevron-up.svg" alt="">
			</a>
		</div>
		<div v-show="panelOpen">
			<Container @drop="onDrop" drag-class="ghost-dragging"
			           :drag-handle-selector="'.drag_action_with_lines'"
			           :drop-placeholder="options" lock-axis="y" >
				<Draggable v-for="(item, index) in listItemsData" :key="index">
					<ContainerBoxEntry :content="content" :index="index" :item="item"
					                   @updated="updatedx()" @delete="removeOption(index)" />
<!--					<div class="social_networks_item">-->
<!--						<div class="top_wrpr">-->
<!--							<h3 class="title">{{ item.title }}</h3>-->
<!--							<a class="drag_action_with_lines">-->
<!--								<i class="icon icon-burger"></i>-->
<!--							</a>-->
<!--						</div>-->
<!--						<input-field small :placeholder="item.title + ' account URL'"-->
<!--						             :value="item.url" @input="updatedData($event, 'url', index)"/>-->
<!--					</div>-->
				</Draggable>
			</Container>
			<div class="flex layout-column margin-t-10 flex-center" >
				<v-button class="" :icon="require('@/assets/img/add_plus_icon.svg')"
				          label="Add new box" @click="addOption" border slim/>
			</div>
		</div>
	</div>
</template>

<script>
import InputField from "@/components/base/input-field";
import InfoIcon from "@/components/base/info-icon";
import VButton from "@/components/base/v-button";
import debounceAction from "@/helpers/debounce";
import VSwitch from '@/components/base/v-switch'
import {Container, Draggable} from 'vue-smooth-dnd'
import {applyDrag} from "@/modules/page-editor/src/utils/helpers";
import ContainerBoxEntry from "@/modules/page-editor/src/components/sidebar/sidebar-items/ContainerBoxEntry";

export default {
	name: 'ContainerProps',
	props: ['title', 'value', 'content'],
	components: {
		ContainerBoxEntry,
		Container,
		Draggable,
		VSwitch,
		VButton,
		InfoIcon,
		InputField
	},
	data: function () {
		return {
			listItemsData: [],
			panelOpen: true,
			localData: {
				optionsType: 'countries',
				options: [],
				required: true,
				showLabel: true,
				dataType: '',
				dataType2: '',
				placeholder: '',
				placeholder2: '',
				value: '',
			},
			options: {
				className: 'cards-drop-preview',
				animationDuration: '150',
				showOnTop: false
			},
		}
	},
	computed: {
		isEmail() {
			return this.localData.dataType==='email' || (this.inputType==='double' && this.localData.dataType2==='email');
		},
		inputType(){
			return this.content.attributes && this.content.attributes.basic ? this.content.attributes.basic.inputType : '';
		}
	},
	methods: {
		updatedData() {
			this.$emit('updated', this.listItemsData);
		},
		onDrop(dropResult) {
			this.listItemsData = applyDrag(this.listItemsData, dropResult);
			this.$emit('updated', this.listItemsData);
		},
		panelOpenToggle(){
			this.panelOpen = !this.panelOpen;
			localStorage.setItem(this.title, this.panelOpen);
		},
		addOption() {
			if (!this.listItemsData) this.listItemsData = [];
			this.listItemsData.push({name:"", value:30 ,type:"%"});
			this.updatedData()
		},
		removeOption(index) {
			if (!this.listItemsData) this.listItemsData = [];
			this.listItemsData.splice(index, 1);
			this.updatedData()
		},
		updatedx() {
			this.$emit('updated', this.listItemsData);
		},
	},
	mounted() {
		if(localStorage.getItem(this.title) !== null) {
			this.panelOpen = !(localStorage.getItem(this.title) === 'false');
		}
	},
	created() {
		this.listItemsData = [...this.value];
	},
}
</script>
<style lang="scss" scoped>
.container-props {

}


.options-panel {
	margin-top: 10px;
	border: 1px dashed silver;
	border-radius: 5px;
	padding: 8px 3px;

	.item {
		display: flex;
		flex-direction: row;
	}
	.headline {
		text-align: center;
		font-weight: bold;
		font-size: 13px;
		color: $grey;
		margin-bottom: 4px;
	}
	.op-header {
		margin: 5px 0;
		span {
			margin-left: 5px;
		}
	}
	.option {
		margin-bottom: 5px;
		.input-field:first-child {
			max-width: 100px;
		}
	}
	.add-option {
		margin: auto;
	}
	.delete_btn {
		min-width: 28px;
		min-height: 28px;
		width: 28px;
		height: 28px;
		border-radius: 5px;
	}
}
.title {
	width: 110px;
	white-space: nowrap;
}
.v-select, .input-field {
	width: 100%;
}
</style>
